import React from "react";
import useSEO from "../hooks/useSEO";
import Reveal from "../components/Reveal";
import { PageHead, CTABand } from "../components/Shared";
import { solutions, solutionStatus } from "../data/solutions";

const initials = (name) => name.replace(/-/g, " ").split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export default function Solutions() {
  useSEO({
    title: "Upcoming Solutions — Products in Development",
    description: "Preview the next-generation software products Victrie is building right now: Piua-AI, YaWote, Riveu, Ailo and Probtic. Track development progress and be first to know at launch.",
    path: "/solutions",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "Victrie upcoming solutions",
      itemListElement: solutions.map((s, i) => ({ "@type": "SoftwareApplication", position: i + 1, name: s.name, applicationCategory: "BusinessApplication", creator: { "@id": "https://victrie.com/#organization" } })),
    },
  });

  return (
    <>
      <PageHead
        crumb="Upcoming Solutions"
        title={<>Solutions <span className="grad-text">launching</span> from our lab</>}
        text="A look at the products Victrie is building right now. Progress is updated as each solution moves toward launch."
      />

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="container grid grid--3">
          {solutions.map((s, i) => {
            const status = solutionStatus(s.progress);
            return (
              <Reveal key={s.name} delay={(i % 3) * 90} className="card solution-card" as="article">
                <div className="card__glow" />
                <div className="solution-card__head">
                  <div className="logo-tile" aria-hidden="true">{initials(s.name)}</div>
                  <span className="solution-card__status" style={{ "--c": status.color }}>{status.label}</span>
                </div>
                <h3>{s.name}</h3>
                <p>{s.tagline}</p>
                <div className="progress" role="progressbar" aria-valuenow={s.progress} aria-valuemin={0} aria-valuemax={100} aria-label={`${s.name} is ${s.progress}% complete`}>
                  <div className="progress__bar" style={{ width: `${s.progress}%` }} />
                </div>
                <div className="progress__label"><span>Development progress</span><strong>{s.progress}% done</strong></div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <CTABand title="Want early access?" text="Tell us which solution you are interested in and we will let you know the moment it launches." primary="Request early access" secondary="Explore services" />
    </>
  );
}
